module.exports = __webpack_public_path__ + "static/assets/5bed0348c297ce0a55e35527c8081cb5.gif";